





























































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
    import PasswordChangeBase from "./PasswordChangeBase";
	@Component
    export default class PasswordChange extends PasswordChangeBase {


		styleBackground() {
			return this.isTestEnvironment ? "background-color:darkcyan;" : "";
		}

        dynamicID() {
            var id = 'dynamicID-' + (Math.floor(Math.random() * Date.now()));
            return id;
        }

		// zobrazeni login stranky funguje jako odhlaseni
		created() {
			this.isLoginPage = true;
			super.setMainDescriptionOld(this.$t('login.login').toString(), this.$t('login.login').toString(), this.$t('login.login').toString(), this.$t('login.login').toString());
			super.setAlertModalId('alertModalIdLogin');
			
			this.versionNumberInLoginPage = "1.3.7x";
			this.getVersionNumberFromREST();
		};

		isCorrectEmail(item: any) {
			this.isCorrectEmailBase(item);
		}

        isCorrectPassNew(value: any) {
            this.isCorrectPassNewBse(value);
        }

        isCorrectPassNew2(value: any) {
            this.isCorrectPassNewBase2(value);
        }


        getVersionNumber() {
            return "verze " + this.versionNumber;
        }

		forgetPassword() {
			this.forgetPasswordBase();
		}

		enterPress(): void {
            this.enterPressBase();
		}

        mounted() {
            this.recongnizeLang();
			if (this.$route.query.code != undefined) {
				this.showEmail = false;
				this.loadUserByUrl(this.$route.query.code.toString());
			}
           
        }
	

	}
